import { render, staticRenderFns } from "./PopProducts.vue?vue&type=template&id=7786e10f&"
import script from "./PopProducts.vue?vue&type=script&lang=js&"
export * from "./PopProducts.vue?vue&type=script&lang=js&"
import style0 from "./PopProducts.vue?vue&type=style&index=0&id=7786e10f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports